export const isPromise = target =>
  typeof target === "object" && typeof target.then === "function";
